import { render, staticRenderFns } from "./TicketDetailsAdmin.vue?vue&type=template&id=bee36a1a&"
import script from "./TicketDetailsAdmin.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports